import styled from 'styled-components';

export const StyledContainer = styled.div`
  background-color: #ffffff;
  padding: 15px 30px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(2, auto);
  gap: 20px 10px;
`;

export const StyledLabel = styled.p`
  font-size: 15px;
  font-weight: bold;
  margin: 0;
  text-align: left;
`;

export const StyledAmount = styled.p`
  font-size: 19px;
  color: #6200ea;
  margin: 0;
  text-align: left;
  font-weight: bold;
`;
